import i18n from '../../core/services/i18n/i18n'
import fingerprint from '../../core/services/fingerprint/fingerprint'

export default {
  images: {
    loggedin: fingerprint.staticMedia('/images/signup_loggedin.jpg'),
    notloggedin: fingerprint.staticMedia('/images/signup_notloggedin.jpg'),
  },
  links: {
    loggedin: '/account/favourites',
    notloggedin: '/register',
  },
  texts: {
    loggedin: i18n.get('SignUp.LoggedInText'),
    notloggedin: i18n.get('SignUp.NotLoggedInText'),
  },
  ctas: {
    loggedin: i18n.get('SignUp.LoggedInCta'),
    notloggedin: i18n.get('SignUp.NotLoggedInCta'),
  },
}
